<template>
  <div class="row">
    <v-layout row wrap>
      <v-flex lg6 md6 sm12 xs12>
        <v-container>
          <v-card flat class="futuristic-card">
            <v-card-title class="card-header">
              <h4 class="earth-color">ADD A PARTNER TYPE</h4>
            </v-card-title>
            <v-container>
              <v-form @submit.prevent="postPartnerType()">
                <v-text-field
                  label="Partner Type"
                  v-model="types.name"
                  :rules="requiredRules"
                  required
                  class="futuristic-input"
                ></v-text-field>
                <v-text-field
                  label="Conservation Fee Discount (eg 10%)"
                  v-model="types.conservation_fee_discount"
                  :rules="requiredRules"
                  required
                  type="number"
                  step="0.1"
                  class="futuristic-input"
                ></v-text-field>
                <v-checkbox
                  label="Partner Bookings can be Invoiced"
                  v-model="types.can_be_invoiced"
                  color="#587e27"
                ></v-checkbox>
                <v-textarea
                  label="Description"
                  v-model="types.desc"
                  :rules="requiredRules"
                  required
                  class="futuristic-input"
                ></v-textarea>
                <v-btn
                  :depressed="true"
                  block
                  class="futuristic-btn"
                  :color="update === false ? 'primary' : 'warning'"
                  type="submit"
                >
                  {{ update === false ? 'Add Partner Type' : 'Update Partner Type' }}
                </v-btn>
              </v-form>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
      <v-flex lg6 md6 sm12 xs12>
        <v-container>
          <v-card flat class="futuristic-card">
            <v-card-title class="card-header">
              <h4 class="earth-color">PARTNER TYPES</h4>
            </v-card-title>
            <v-container>
              <table cellpadding="1" cellspacing="1" class="futuristic-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Partner Type</th>
                    <th>Conservation Fee Discount</th>
                    <th>Can Be Invoiced</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(type, index) in allPartnerTypes" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ type.name }}</td>
                    <td>{{ type.conservation_fee_discount }}%</td>
                    <td>{{ type.can_be_invoiced ? 'Yes' : 'No' }}</td>
                    <td>
                      <v-btn
                        :depressed="true"
                        small
                        class="futuristic-btn"
                        color="error"
                        @click="deletePartnerType(type.public_id)"
                        v-if="type.public_id !== '4abc0d64' && type.public_id !== '6bac8c28' && type.public_id !== '90b00b2b'"
                      >
                        Disable
                      </v-btn>
                      <v-btn
                        :depressed="true"
                        small
                        class="futuristic-btn"
                        :color="update === false ? 'info' : 'warning'"
                        @click="update === false ? amendPartnerType(index) : cancelAmmendment()"
                      >
                        {{ update === false ? 'Amend' : 'Cancel Amendment' }}
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      update: false,
      types: {
        name: '',
        desc: '',
        conservation_fee_discount: 0,
        public_id: '',
        can_be_invoiced: false,
        session_id: localStorage.getItem('lkjhgfdsa')
      }
    };
  },
  created() {
    this.$store.dispatch('get_all_partner_types');
  },
  methods: {
    amendPartnerType: function (index) {
      this.update = true;
      this.types.name = this.allPartnerTypes[index].name;
      this.types.desc = this.allPartnerTypes[index].desc;
      this.types.conservation_fee_discount = this.allPartnerTypes[index].conservation_fee_discount;
      this.types.public_id = this.allPartnerTypes[index].public_id;
      this.types.can_be_invoiced = this.allPartnerTypes[index].can_be_invoiced;
    },
    cancelAmmendment: function () {
      this.update = false;
      this.types.name = '';
      this.types.desc = '';
      this.types.conservation_fee_discount = '';
      this.types.public_id = '';
      this.types.can_be_invoiced = false;
    },
    deletePartnerType: function (publicId) {
      this.$store.dispatch('delete_partner_type', publicId);
    },
    postPartnerType: function () {
      if (this.update === false) {
        this.$store.dispatch('post_partner_type', this.types);
      } else {
        this.$store.dispatch('update_partner_type', this.types);
      }
    }
  }
};
</script>

<style scoped>
/* Futuristic Card */
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
}

.futuristic-search {
  max-width: 250px;
}

.futuristic-search >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.futuristic-table {
  border-radius: 8px;
  margin: 0 8px 8px;
}

.futuristic-table >>> table {
  border-collapse: separate;
  border-spacing: 0;
}

.futuristic-table >>> thead tr th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  color: #587e27;
  font-weight: 600;
  font-size: 13px;
}

.futuristic-table >>> tbody tr {
  transition: background-color 0.2s ease;
}

.futuristic-table >>> tbody tr:hover {
  background-color: #f5f7fa;
}

.futuristic-link {
  color: #1976d2;
  text-decoration: none;
  font-weight: 500;
}

.futuristic-link:hover {
  color: #0d47a1;
}

.futuristic-alert {
  border-radius: 8px;
  margin: 8px;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .card-header {
    flex-direction: column;
    align-items: flex-start;
    padding: 12px;
  }

  .futuristic-search {
    max-width: 100%;
    margin-top: 12px;
  }

  .futuristic-table {
    margin: 0 4px 4px;
  }

  .futuristic-table >>> thead tr th {
    font-size: 12px;
    padding: 0 8px;
  }

  .futuristic-table >>> tbody tr td {
    font-size: 12px;
    padding: 0 8px;
  }

  .futuristic-btn {
    font-size: 0.9rem;
  }
}

@media (max-width: 600px) {
  .futuristic-card {
    border-radius: 6px;
  }

  .futuristic-btn {
    font-size: 0.85rem;
  }

  .futuristic-table {
    margin: 0 4px 4px;
    overflow-x: auto;
  }

  .futuristic-table >>> table {
    min-width: 700px; /* Ensure table is wide enough for all columns */
  }

  .futuristic-table >>> thead {
    display: table-header-group;
  }

  .futuristic-table >>> tbody tr {
    display: table-row;
  }

  .futuristic-table >>> tbody tr td {
    display: table-cell;
    font-size: 0.85rem;
    padding: 6px 8px;
  }

  .futuristic-table >>> thead tr th {
    font-size: 0.85rem;
    padding: 6px 8px;
  }
}
</style>
